/*
 * ConfigProjectList.tsx
 * This Config Project list Component is used to display the list of project categories and status.
 */
import { useContext, useEffect, useState } from "react";
import { eASSESSMENT, ePrivileges } from "../../../utils/enum";
import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "./assessment.module.css";
import DesignationList from "./designation/list";
import KPIList from "./kpis/list";

function AssessmentWrapper() {
  const context: any = useContext(UserContext);
  const [activeProject, setActiveProject] = useState<string>(
    eASSESSMENT.DESIGNATION
  );

  return (
    <div>
      <div className={styles.parentContainer}>
        {/* Check if user has permission to view already downloaded report list */}
        {/* {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWTASKCONFIGURATION
        ) && ( */}
        <div
          className={`${styles.tab} ${activeProject === eASSESSMENT.DESIGNATION ? styles.activeTab : ""
            }`}
          onClick={() => {
            setActiveProject(eASSESSMENT.DESIGNATION);
          }}
        >
          <span
            className={
              activeProject === eASSESSMENT.DESIGNATION
                ? styles.activeText
                : styles.inactiveText
            }
          >
            Designations
          </span>
        </div>
        {/* )} */}

        {/* {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWSTATUSCONFIGURATION
        ) && ( */}
        <div
          className={`${styles.tab} ${activeProject === eASSESSMENT.KPI ? styles.activeTab : ""
            }`}
          onClick={() => {
            setActiveProject(eASSESSMENT.KPI);
          }}
        >
          <span
            className={
              activeProject === eASSESSMENT.KPI
                ? styles.activeText
                : styles.inactiveText
            }
          >
            KPI Management
          </span>
        </div>
        {/* )} */}
      </div>
      <div>
        {activeProject === eASSESSMENT.DESIGNATION ? (
          <DesignationList />
        ) : activeProject === eASSESSMENT.KPI ? (
          <KPIList />
        ) : null}
      </div>
    </div>
  );
}

export default AssessmentWrapper;
